import React, { Component } from "react";
import { Box, Text } from "rebass";
import { blue500 } from "material-ui/styles/colors";
import Dialog from "material-ui/Dialog";
import RaisedButton from "material-ui/RaisedButton";
import TextField from "material-ui/TextField";
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from "material-ui/Table";
import { RESTApiCorporate } from "../restClient";
import { cyan500 } from "material-ui/styles/colors";

class DialogListEmail extends Component {
  state = {
    open: false,
    listEmail: [],
    oldList: []
  };
  onShowDialog = () => {
    this.setState({
      open: true
    });
    // console.log(this.props.match.params.id);
    const { match } = this.props;
    if (match.params.id) {
      this.getListEmail(match.params.id);
    }
  };

  getListEmail = paramsId => {
    RESTApiCorporate(paramsId)
      .then(response => response.json())
      .then(item => {
        // console.log(item);
        if (item && item.length > 0) {
          this.setState({
            listEmail: item,
            oldList: item
          });
        }
      });
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  onSearch = (event, value) => {
    setTimeout(this.onResultSearch.bind(this, value), 500);
  };
  onResultSearch = value => {
    const { oldList } = this.state;
    const result = [];

    oldList.map((item, index) => {
      const email = item.email.toLowerCase();
      const valueEmail = value.toLowerCase();
      if (email && email.search(new RegExp(valueEmail)) !== -1) {
        result.push(item);
        return item;
      }
      return null;
    });
    // console.log(result);
    this.setState({
      listEmail: result
    });
  };

  render() {
    const actions = [
      <RaisedButton label="Close" primary={true} onClick={this.handleClose} />
    ];
    const { listEmail } = this.state;
    return (
      <div>
        <TextDialogButton onClick={this.onShowDialog}>
          View List
        </TextDialogButton>
        <Dialog
          title="List Email"
          actions={actions}
          modal={true}
          open={this.state.open}
          onRequestClose={this.handleClose}
          autoScrollBodyContent={true}
        >
          <Box w={[1]}>
            <Box>
              <TextField
                hintText="Search..."
                onChange={this.onSearch.bind(this)}
              />
            </Box>
            <Table selectable={false}>
              <TableHeader
                displaySelectAll={false}
                adjustForCheckbox={false}
                style={{ backgroundColor: cyan500 }}
              >
                <TableRow>
                  <TableHeaderColumn style={{ color: "#FFFFFF" }}>
                    Email
                  </TableHeaderColumn>
                  >
                </TableRow>
              </TableHeader>
              <TableBody displayRowCheckbox={false}>
                {listEmail.map((item, index) => {
                  return (
                    <TableRow key={index}>
                      <TableRowColumn>{item.email}</TableRowColumn>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Box>
        </Dialog>
      </div>
    );
  }
}

const TextDialogButton = Text.extend`
  color: ${blue500};
  cursor: pointer;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-color: ${blue500};
`;

export default DialogListEmail;



// WEBPACK FOOTER //
// ./src/corporate_campaign/DialogListEmail.js